import React from 'react'
import '../styles/copyRight.css'

const CopyRight = () => {
    return (
        <>
            <hr />
            <h1 className='copyRight'>
            Copyright © 2010 - 2022 Xiaomi. All Rights Reserved
            </h1>
        </>
    )
}

export default CopyRight
